export default "__VITE_ASSET__CTx$rWVs__"